import { useContent } from '../../../hooks/use-server-content';

export interface DylLandingProps {
    first5050CardTitle: string;
    first5050CardBody: string;
    first5050CardImage: string;
    first5050CardImageAltText: string;
    first5050CardImageSide: string;
    first5050CardCtaLabel: string;
    first5050CardCtaLink: string;
    first5050CardDisclaimer: string;
    second5050CardTitle: string;
    second5050CardBody: string;
    second5050CardImage: string;
    second5050CardImageAltText: string;
    second5050CardImageSide: string;
    second5050CardCtaLabel: string;
    second5050CardCtaLink: string;
    second5050CardDisclaimer: string;
    fourth5050CardTitle: string;
    fourth5050CardBody: string;
    fourth5050CardImage: string;
    fourth5050CardImageAltText: string;
    fourth5050CardImageSide: string;
    fourth5050CardCtaLabel: string;
    fourth5050CardCtaLink: string;
    fourth5050CardDisclaimer: string;
    bannerSignIntoMyLincolnText: string;
    bannerVehicleUnsupportedPageText: string;
}

export const useDylLandingContent = (): DylLandingProps | null => {
    const [content, getValueByName] = useContent(
        'dyf/dyl-landing-page',
        'dyl-landing'
    );
    let contentFragment: any = {};
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    if (contentFragment) {
        if (contentFragment.hide) {
            contentFragment = null;
        }
    }
    return contentFragment as DylLandingProps;
};
